import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  ClickAwayListener,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import FragmentSwitches from "./fragmentSwitches";
import FragmentSlider from "./fragmentSlider";

const FragmentSettingsCard = (props) => {
  const { open, handleSettings } = props;

  const MyCard = () => {
    return (
      <ClickAwayListener onClickAway={handleSettings(false)}>
        <Card sx={{ maxWidth: "250px", minWidth: "250px" }}>
          <CardHeader
            title="Réglages"
            // subheader="Planches de fragments"
            action={
              <IconButton onClick={handleSettings(false)} title="Fermer">
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <FragmentSlider title="pochage" param="diffuse" />
            <FragmentSlider title="relief" param="normale" />
            <FragmentSwitches />
          </CardContent>
        </Card>
      </ClickAwayListener>
    );
  };

  return open ? <MyCard /> : null;
};

export default FragmentSettingsCard;
